import { useState } from "react";
import { DatePickerCalendar, DatePickerProps } from "./datePicker";

export const DatePickerControl = (props: DatePickerProps) => (
  <DatePickerCalendar  {...props} />
)

interface DatePickerStateControlProps extends Omit<DatePickerProps, "selected"> {
  selected: string | null;
}

export const DatePickerStateControl = (props: DatePickerStateControlProps) => {

  const [datePicker, setDatePicker] = useState(
    props.selected !== null ? new Date(props.selected) : null
  );

  return (
    <DatePickerCalendar
      {...props}
      selected={datePicker}
      onChange={(e) => {
        props.onChange(e);
        setDatePicker(e);
      }}
    />
  )
}